import { RuleResultGood } from './rule'
import * as Rules from './rules'
import Utils from '@/utils'

export class FantasyRuleManager {
  constructor (rule) {
    this.rule = rule
    this.fulfillments = []
    this.build()
  }

  build () {
    this.fulfillments.push(
      new Rules.CreditsRule('Credits', 0, this.rule.credits)
    )

    this.fulfillments.push(
      new Rules.UniquePlayerRule('Unique Players')
    )

    if (this.rule.min_players || this.rule.max_players) {
      this.fulfillments.push(
        new Rules.PlayersCountRule('Players', this.rule.min_players, this.rule.max_players)
      )
    }

    if (this.rule.boost_names) {
      this.fulfillments.push(
        new Rules.BoostPlayerRule('Boost', this.rule.boost_names)
      )
    }

    if (this.rule.min_players_per_team || this.rule.max_players_per_team) {
      this.fulfillments.push(
        new Rules.PlayerPerTeamRule('Players per Team', this.rule.min_players_per_team, this.rule.max_players_per_team)
      )
    }

    if (this.rule.min_players_per_match || this.rule.max_players_per_match) {
      this.fulfillments.push(
        new Rules.PlayerPerMatchRule('Players per Match', this.rule.min_players_per_match, this.rule.max_players_per_match)
      )
    }

    if (this.rule.min_teams || this.rule.max_teams) {
      this.fulfillments.push(
        new Rules.TeamCountRule('Teams', this.rule.min_teams, this.rule.max_teams)
      )
    }

    if (this.rule.min_matches || this.rule.max_matches) {
      this.fulfillments.push(
        new Rules.MatchCountRule('Matches', this.rule.min_matches, this.rule.max_matches)
      )
    }

    for (const role in this.rule.max_players_by_role) {
      const lower = this.rule.min_players_by_role[role]
      const upper = this.rule.max_players_by_role[role]

      if (lower || upper) {
        this.fulfillments.push(
          new Rules.RoleCountRule(Utils.capitalise(role), lower, upper, role)
        )
      }
    }
  }

  canSelectPlayer (key, selectionState) {
    let result = RuleResultGood
    for (const ff of this.fulfillments) {
      result = ff.canSelect(key, selectionState)
      if (!result.pass) {
        return result
      }
    }
    return result
  }

  validate (selectionState) {
    let result = RuleResultGood
    for (const ff of this.fulfillments) {
      result = ff.isFulfilled(selectionState)
      if (!result.pass) {
        return result
      }
    }
    return result
  }
}
